module.exports = __webpack_public_path__ + "static/7-95bf1609c6497baa8071b693ceb6c91c.jpg";